/**
 * @fileoverview GET handler for the "/engagement/campaigns/:app_group_id/searchable" endpoint
 * Lightweight, searchable campaign list used to back typeahead pickers (e.g. the Campaign QA
 * agent preview). Returns only {id, value, is_draft} so it stays fast on large app groups.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsAppGroupIdSearchable, searchableCampaignsDefaultLimit } from "./constants";
import type { CampaignsSearchableResult, CampaignsSearchableParams } from "./types";
import { isCampaignsSearchableResult } from "./validators";

export const getEngagementCampaignsAppGroupIdSearchable = reactQueryFetcherAdapter(
  engagementCampaignsAppGroupIdSearchable,
  (signal: AbortSignal, params: CampaignsSearchableParams): Promise<CampaignsSearchableResult> => {
    return fetch(
      `/engagement/campaigns/${params.appGroupId}/searchable`,
      "GET",
      { query: params.query ?? "", limit: params.limit ?? searchableCampaignsDefaultLimit },
      { signal }
    );
  },
  isCampaignsSearchableResult
);
